import React from 'react';

export default class InProgressWorkShops extends React.Component {

  render(){
    return(
      <main className="main-content">
        <div className="container-fluid">
          <div className="dashboard row">
            <div className="col-12 col-md-6">
              <div className="card regular card-bottom-gutter">
                <div className="card-top-wrap">
                  <div className="card-head">
                    <div className="card-head-top">
                      <div className="card-head-avatar-holder">
                        <div className="card-head-avatar">
                          <img src="styles/img/card-ava.jpg" alt="avatar"/>
                        </div>
                        <div className="card-head-name-holder">
                          <span className="card-head-title">PROVIDED BY</span>
                          <span className="card-head-name">Michael O'Carroll</span>
                        </div>
                      </div>
                    </div>
                    <p className="card-title">CCT: 1 WEEK. Systemic Approaches to Working with Individuals,
                      Families and Organisations</p>
                  </div>
                  <div className="card-content">
                    <p className="card-desc">The cornerstones of atrial fibrillation (AF) management are rate
                      control and
                      anticoagulation and rhythm control for those symptomatically limited by AF. The
                      clinical
                      decision to use a rhythm-control ...</p>
                  </div>
                </div>
                <div className="card-footer">
                  <div className="card-footer-top">
                    <p className="card-audience">
                      Audience:
                      <span>Counsellor</span>
                      <span>&sbquo;</span>
                      <span>Psychotherapist</span>
                    </p>
                  </div>
                  <div className="card-footer-bottom">
                    <ul className="card-info">
                      <li>
                        <p className="card-info-title">
                          MODULES:
                          <span className="card-info-sub">6</span>
                        </p>
                      </li>
                      <li>
                        <p className="card-info-title">
                          CPD:
                          <span className="card-info-sub">46h</span>
                        </p>
                      </li>
                    </ul>
                    <a href="#" className="btn card-btn bordered prime">
                      in progres
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-6">
              <div className="card regular card-bottom-gutter">
                <div className="card-top-wrap">
                  <div className="card-head">
                    <div className="card-head-top">
                      <div className="card-head-avatar-holder">
                        <div className="card-head-avatar">
                          <img src="styles/img/card-ava.jpg" alt="avatar"/>
                        </div>
                        <div className="card-head-name-holder">
                          <span className="card-head-title">PROVIDED BY</span>
                          <span className="card-head-name">Michael O'Carroll</span>
                        </div>
                      </div>
                    </div>
                    <p className="card-title">CCT: 1 WEEK. Systemic Approaches to Working with Individuals,
                      Families and Organisations</p>
                  </div>
                  <div className="card-content">
                    <p className="card-desc">The cornerstones of atrial fibrillation (AF) management are rate
                      control and
                      anticoagulation and rhythm control for those symptomatically limited by AF. The
                      clinical
                      decision to use a rhythm-control ...</p>
                  </div>
                </div>
                <div className="card-footer">
                  <div className="card-footer-top">
                    <p className="card-audience">
                      Audience:
                      <span>Counsellor</span>
                      <span>&sbquo;</span>
                      <span>Psychotherapist</span>
                    </p>
                  </div>
                  <div className="card-footer-bottom">
                    <ul className="card-info">
                      <li>
                        <p className="card-info-title">
                          MODULES:
                          <span className="card-info-sub">6</span>
                        </p>
                      </li>
                      <li>
                        <p className="card-info-title">
                          CPD:
                          <span className="card-info-sub">46h</span>
                        </p>
                      </li>
                    </ul>
                    <a href="#" className="btn card-btn bordered prime">
                      in progres
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-6">
              <div className="card regular card-bottom-gutter">
                <div className="card-top-wrap">
                  <div className="card-head">
                    <div className="card-head-top">
                      <div className="card-head-avatar-holder">
                        <div className="card-head-avatar">
                          <img src="styles/img/card-ava.jpg" alt="avatar"/>
                        </div>
                        <div className="card-head-name-holder">
                          <span className="card-head-title">PROVIDED BY</span>
                          <span className="card-head-name">Michael O'Carroll</span>
                        </div>
                      </div>
                    </div>
                    <p className="card-title">CCT: 1 WEEK. Systemic Approaches to Working with Individuals,
                      Families and Organisations</p>
                  </div>
                  <div className="card-content">
                    <p className="card-desc">The cornerstones of atrial fibrillation (AF) management are rate
                      control and
                      anticoagulation and rhythm control for those symptomatically limited by AF. The
                      clinical
                      decision to use a rhythm-control ...</p>
                  </div>
                </div>
                <div className="card-footer">
                  <div className="card-footer-top">
                    <p className="card-audience">
                      Audience:
                      <span>Counsellor</span>
                      <span>&sbquo;</span>
                      <span>Psychotherapist</span>
                    </p>
                  </div>
                  <div className="card-footer-bottom">
                    <ul className="card-info">
                      <li>
                        <p className="card-info-title">
                          MODULES:
                          <span className="card-info-sub">6</span>
                        </p>
                      </li>
                      <li>
                        <p className="card-info-title">
                          CPD:
                          <span className="card-info-sub">46h</span>
                        </p>
                      </li>
                    </ul>
                    <a href="#" className="btn card-btn bordered prime">
                      in progres
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/InProgressWorkShops.jsx